let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bH0RB")).then(() => parcelRequire('5ExgM'));